import { applyMiddleware, createStore } from "redux";
import { ADDTOCART, REMOVEFROMCART } from "./cart/actionTypes";
import { rootReducer } from "./rootReducer";


const checkProductQuantity = (store) => next => action => {
    const state = store.getState();
    const cartProduct = state.cart.cartItems.find(cart => cart.productId === action.payload);
    const product = state.products.productItems.find(product => product.id === action.payload);

    if(cartProduct.quantity === product.quantity && action.type === ADDTOCART) {
        alert("Max Quantity reached");
    } else if(cartProduct.quantity === 0 && action.type === REMOVEFROMCART) {
        alert("Quantity can't be less than 0");
    } 
    else {
        return next(action);
    }
}; 

export const store = createStore(rootReducer, applyMiddleware(checkProductQuantity));